import React, { useEffect, useImperativeHandle, useState } from 'react'

import { IQuestionComponentProps, IQuestionComponentRef, QuestionViewFrame } from '../types'
import { IInstructionResponseValidation, InstructionQuestionModelTypes, InstructionResponse } from './types'

import useTimeline from '../../modules/timeline/useTimeline'
import useSession from '../../session/useSession'
import QuestionFrame from '../_common/QuestionFrame/QuestionFrame'
import InstructionView from './View'

const InstructionQuestion = React.memo(
  React.forwardRef<IQuestionComponentRef, IQuestionComponentProps<InstructionQuestionModelTypes>>(({ model }, ref) => {
    const [[response, responseValidation, frame]] = useState<
      [InstructionResponse, IInstructionResponseValidation, QuestionViewFrame]
    >([model.response, model.responseValidation, model.frame])

    const session = useSession()
    const timeline = useTimeline()

    useEffect(() => {
      session.enableNext(responseValidation.valid && !model.schema.dead_end)
    }, [session, responseValidation.valid, model.schema.dead_end])

    useImperativeHandle<IQuestionComponentRef, IQuestionComponentRef>(ref, () => {
      return {
        tryNext() {
          if ((model.responseValidation.valid && !model.schema.dead_end) || session.skipValidation) {
            return false
          } else {
            session.enableNext(false)
            return true
          }
        },
        tryPrev() {
          return false
        }
      }
    }, [model, session])

    const onUpdateResponse = (response: InstructionResponse) => response

    return (
      <QuestionFrame model={model}>
        <InstructionView
          schema={model.schema}
          response={response}
          responseValidation={responseValidation}
          onUpdateResponse={onUpdateResponse}
          frame={frame}
          timeline={timeline}
        />
      </QuestionFrame>
    )
  }),
  (prevProps, nextProps) => prevProps.model === nextProps.model
)

InstructionQuestion.displayName = 'InstructionQuestion'

export default InstructionQuestion
